export default __webpack_public_path__ + "static/media/background-popup-redeem.8b488743.png";